<template>
    <views v-if="isRender" class="prize">
        <views v-if="!showPrize">
            <disc-input-info
                v-if="activityPlayType === 1"
                v-model="isSaving"
                :name="prizeName"
                :imgs="imgObj"
                :custom-list="customList"
                @save="handleSave">
            </disc-input-info>
            <square-input-info
                v-if="activityPlayType === 2"
                v-model="isSaving"
                :name="prizeName"
                :imgs="imgObj"
                :custom-list="customList"
                @save="handleSave">
            </square-input-info>
        </views>
        <views v-else>
            <disc-prize
                v-if="activityPlayType === 1"
                v-model='isPrizing'
                :gift-list="giftList"
                :result="prizeResult"
                :name="prizeName"
                :imgs="imgObj"
                @prize="handlePrize"
                @saveAddrs="handleAddAddrs">
            </disc-prize>
            <square-prize
                v-if="activityPlayType === 2"
                v-model='isPrizing'
                :gift-list="giftList"
                :result="prizeResult"
                :name="prizeName"
                :imgs="imgObj"
                @prize="handlePrize"
                @saveAddrs="handleAddAddrs">
            </square-prize>
            <empty v-if="noPrize"></empty>
        </views>
    </views>
</template>

<script>
import DiscInputInfo from './discPrize/InputInfo'
import SquareInputInfo from './squarePrize/InputInfo'
import DiscPrize from './discPrize'
import SquarePrize from './squarePrize'
import Empty from './empty'
import tools from '@/mixins/tools'
import address from '@/mixins/address'
import storage from '@/utils/storage'
import api from '@/utils/api'
export default {
    name: 'Prize',
    components: {
        DiscInputInfo,
        SquareInputInfo,
        DiscPrize,
        SquarePrize,
        Empty
    },
    mixins: [tools, address],
    data() {
        return {
            isRender: false,
            showPrize: false,
            form: {},
            giftList: [],
            isPrizing: false, // 是否抽奖中
            prizeResult: {}, // 抽奖结果
            customList: [], // 自定义属性列表
            isSaving: false, // 是否保存自定义属性中
            squarePrizeAddressBg: require('@/assets/images/squarePrize/addres_bg.png'),
            discPrizeAddressBg: require('@/assets/images/discPrize/addres_bg.png')
        }
    },
    computed: {
        query() {
            return this.$route.query
        },
        // 没有抽奖活动
        noPrize() {
            return !storage.get('prizeObj')
        },
        prizeObj() {
            return JSON.parse(storage.get('prizeObj'))
        },
        prizeName() {
            return this.prizeObj.name
        },
        activityPlayType() {
            return this.prizeObj.activity_play_type
        },
        activityId() {
            return this.prizeObj.id
        },
        giftTypeList() {
            return this.prizeObj.gift_list
        },
        imgObj() {
            return {
                prize1: this.prizeObj.top_image_url,
                prize2: this.prizeObj.medium_image_url,
                prize3: this.prizeObj.bottom_image_url,
                prize4: this.prizeObj.bottom_prize_image_url,
                prizePointer: this.prizeObj.point_image_url,
                prizeRule: this.prizeObj.rule_image_url,
                bg: this.prizeObj.background_image_url,
                contentBg: this.prizeObj.win_image_url,
                addressBg: this.activityPlayType === 1 ? this.discPrizeAddressBg : this.squarePrizeAddressBg
            }
        }
    },
    beforeMount() {
        if (this.noPrize) {
            this.isRender = true
            this.showPrize = true
        } else {
            if (!this.query.public_code) {
                this.push('/verify?type=prize&public=1')
                return
            }
            if (!this.query.secret_code) {
                this.push(`/verify?type=prize&public=2&public_code=${this.query.public_code}&verify_record_id=${this.query.verify_record_id}`)
                return
            }
            this.isRender = true
            this.form.code_public = this.query.public_code
            this.form.code_secret = this.query.secret_code
            this.getActivityCustom()
            this.getPrizeList(this.activityId)
        }
    },
    mounted() {
        this.prize_record_id = ''
    },
    methods: {
        // 保存自定义属性
        handleSave(items) {
            const required = items.filter(item => item.type < 4 && !item.value && item.is_required)
            if (required.length > 0) return this.notify('有必填项未填写')
            const params = {
                list: items.filter(item => item.type < 4 && item.value).map(item => ({
                    id: item.id,
                    value: item.value
                }))
            }
            this.isSaving = true
            api.saveCustom(params).then((res) => {
                if (res.code === 0) {
                    this.sucMsg('保存成功')
                    this.showPrize = true
                } else {
                    this.notify('保存失败')
                }
                this.isSaving = false
            }).then(() => {
                this.isSaving = false
            })
        },
        handlePrize() {
            const params = {
                activity_id: this.activityId,
                code_public: this.form.code_public,
                code_secret: this.form.code_secret,
                address: this.getAddress
            }
            api.luckydraw(params).then((r) => {
                const res = r.data
                this.prize_record_id = res.prize_record_id
                if (res.red_packet_amount >= 0 && res.gift_name !== '') {
                    setTimeout(() => {
                        this.isPrizing = false
                        this.prizeResult = {
                            ...res,
                            giftIcon: res.isWin ? this.giftTypeList.filter(item => item.id === res.gift_id)[0].gift_icon : ''
                        }
                        this.scrollToTop()
                        if (res.isWin) this.getPrizeList(this.activityId)
                    }, 2000) // 指针旋转时间
                } else {
                    this.msg(res.msg)
                    this.isPrizing = false
                }
            }).catch(() => {
                this.isPrizing = false
            })
        },
        getPrizeList(id) {
            const params = {
                page: 1,
                page_size: 100,
                id
            }
            api.getPrizeList(params).then((res) => {
                if (res.data.list) {
                    this.giftList = res.data.list
                }
            })
        },
        // 获取自定义属性
        getActivityCustom() {
            const params = {
                id: this.activityId
            }
            api.getActivityCustom(params).then((res) => {
                console.log('获取抽奖用户自定义属性', res)
                if (res) {
                    this.customList = res.data
                    // const isInput = res.data.filter(item => item.type < 4 && !item.value)
                    //    TODO 暂时不跳过填写，注释
                    // if (isInput.length === 0) this.showPrize = true
                }
            })
        },
        // 添加收货地址
        handleAddAddrs(form) {
            console.log(form)
            form.prize_record_id = this.prize_record_id
            api.addAddrs({ ...form }).then((res) => {
                if (res.data.success) {
                    this.sucMsg('添加收货地址成功')
                    this.push('/')
                }
            })
        }
    }
}
</script>
